"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _WarningYellowOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/WarningYellowOutline"));

var _spinner = _interopRequireDefault(require("../../spinner"));

var _utils = require("../utils");

var _tooltip = _interopRequireDefault(require("../../tooltip/tooltip"));

var TableHeaderCell = function TableHeaderCell(_ref) {
  var className = _ref.className,
      column = _ref.column;
  var isLoading = column.isLoading,
      isError = column.isError;
  return /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    overflowOnly: true,
    text: (0, _utils.isString)(column.title) ? column.title : function () {
      return column.title;
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, column.title), isLoading && /*#__PURE__*/_react["default"].createElement(_spinner["default"], {
    size: "sm",
    className: "oui-ml-1 oui-mr-1"
  }), isError && /*#__PURE__*/_react["default"].createElement(_tooltip["default"], {
    text: "Error loading data",
    placement: "bottom"
  }, /*#__PURE__*/_react["default"].createElement(_WarningYellowOutline["default"], {
    size: "sm",
    className: "oui-ml-1 oui-mr-1",
    muted: false
  })));
};

TableHeaderCell.propTypes = {
  className: _propTypes["default"].string,
  column: _propTypes["default"].object
};
var _default = TableHeaderCell;
exports["default"] = _default;